"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgLocationInAnexBuilding = function SvgLocationInAnexBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4D4D4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 9h4.997l-.003-1.052 4.045.034L14.03 9H19v13H5zm7.017-1.433V5.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 19h2v3h-2zm0-4h2v2h-2zm-4 0h2v2H7zm8 0h2v2h-2zm-8 2h2v2H7zm8 0h2v2h-2zm-4-6h2v2h-2zm-4 0h2v2H7zm8 0h2v2h-2zM9.901 6.914 11.68 2h.603l1.877 4.914-.633-1.601h-3.064"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgLocationInAnexBuilding);
var _default = exports["default"] = Memo;